"use client";
import React, {useEffect, useState} from "react";
import styles from "../redeem.module.css";
import RedeemAccountUtil from "@/app/(redeem)/redeemAccount/RedeemAccountUtil";
import {RedeemAccountUIProps} from "@/app/(redeem)/redeemAccount/RedeemAccountUI";

type AccountInfoComProps = {
    onCallInfo: (a: string, b: string,isOk:boolean) => void,
    data: RedeemAccountUIProps
}

const AccountInfoCom: React.FC<AccountInfoComProps> = (props) => {
    const {data, onCallInfo} = props;
    const {channelData, channelCheckData} = data;
    const [account, setAccount] = useState('');
    const [accountError, setAccountError] = useState('');
    const [cAccount, setCAccount] = useState('');
    const [confirmAccountError, setConfirmAccountError] = useState('');
    const [isOK, setIsOK] = useState<boolean>(false);

    useEffect(() => {
        onCallInfo(account, cAccount, isOK);
    }, [account, cAccount, isOK]);

    const onAccountChange = (value: string) => {
        setAccount(value);
        if (!value) {
            setAccountError('Please enter your account');
            setIsOK(false);
            return;
        }
        //帐号是否OK
        const accountOk = RedeemAccountUtil.VerifyEmail(value);
        if (!accountOk) {
            setAccountError('Invalid input');
            setIsOK(false);
            return;
        }
        setAccountError('');
        if (cAccount){
            onConfirmAccountChange(cAccount);
        }
    }

    const onConfirmAccountChange = (value: string) => {
        setCAccount(value);
        if (!value) {
            setConfirmAccountError('Please enter your account');
            setIsOK(false);
            return;
        }
        //帐号是否OK
        const accountOk = RedeemAccountUtil.VerifyEmail(value);
        if (!accountOk) {
            setConfirmAccountError('Account do not match');
            setIsOK(false);
            return;
        }
        //和上面的帐号不匹配
        if (value != account) {
            setConfirmAccountError('Account do not match');
            setIsOK(false);
            return;
        }
        setConfirmAccountError('');
        setIsOK(true);
    }

    return (
        <>
            {/* 信息输入 */}
            <div className={`${styles.emailBox} ${styles.content}`}>
                <div className={`center ${styles.eTitle}`}>Your Redemption Details</div>
                <div className={styles.inputBox}>
                    <div className={`center ${styles.inputItem}`}>
                        <div className={styles.inputName}>Account:</div>
                        <div className={`${styles.input} center`}>
                            <input
                                className={styles.form_input}
                                type='text'
                                placeholder='Enter Your Account'
                                value={account}
                                onChange={e => onAccountChange(e.target.value)}
                                onBlur={e => onAccountChange(e.target.value)}
                            />
                            {accountError && <div className={styles.err}>{accountError}</div>}
                        </div>
                    </div>
                    <div className={`center ${styles.inputItem}`}>
                        <div className={styles.inputName}>Confirm Account:</div>
                        <div className={styles.input}>
                            <input type='text' placeholder='Confirm Your Account'
                                   value={cAccount}
                                   onChange={e => onConfirmAccountChange(e.target.value)}
                            />
                            {confirmAccountError && <div className={styles.err}>{confirmAccountError}</div>}
                        </div>
                    </div>
                </div>
                <div className={styles.info}>Please input the correct account and ensure it's
                    activated, or redemption may fail or be delayed.
                </div>
            </div>
        </>
    )
}

export default AccountInfoCom;